export const API_ENV_STORAGE_KEY = 'fancian-admin-api-env';
export const API_ENV_PROD = 'prod';
export const API_ENV_TEST = 'test';

let boundEnvironment = null;

// A mounted UI binds its environment; another tab cannot redirect its requests.
export function bindApiEnvironment(value) { boundEnvironment = normalizeApiEnvironment(value); }

const VALID_ENVS = new Set([API_ENV_PROD, API_ENV_TEST]);

export function normalizeApiEnvironment(value) {
  const normalized = String(value || '').toLowerCase();
  return VALID_ENVS.has(normalized) ? normalized : API_ENV_PROD;
}

export function getApiEnvironment() {
  const buildDefault = normalizeApiEnvironment(process.env.REACT_APP_API_ENV);
  if (typeof window === 'undefined') {
    return buildDefault;
  }

  try {
    const stored = window.localStorage.getItem(API_ENV_STORAGE_KEY);
    return VALID_ENVS.has(String(stored || '').toLowerCase()) ? normalizeApiEnvironment(stored) : buildDefault;
  } catch {
    return buildDefault;
  }
}

export function setApiEnvironment(nextEnv) {
  const normalized = normalizeApiEnvironment(nextEnv);
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(API_ENV_STORAGE_KEY, normalized);
    } catch {
      // ignore write errors (private mode, blocked storage)
    }
  }
  return normalized;
}

/**
 * Resolved API tier for admin requests (auth / config-admin), aligned with backend ENV_TYPE buckets.
 * Prefers persisted UI selection, then CRA build-time `REACT_APP_API_ENV`.
 */
export function getSelectedEnvironment() {
  if (boundEnvironment) return boundEnvironment;
  const envFromBuild = String(process.env.REACT_APP_API_ENV || '').toLowerCase();
  const envFromRuntime = getApiEnvironment();
  if (envFromRuntime === API_ENV_TEST || envFromRuntime === API_ENV_PROD) {
    return envFromRuntime;
  }
  if (envFromBuild === API_ENV_TEST || envFromBuild === API_ENV_PROD) {
    return envFromBuild;
  }
  return API_ENV_PROD;
}
